export default "__VITE_ASSET__DwM1GbjS__"